module.exports = __webpack_public_path__ + "img/fond-home-activite.0f97a8b7.jpg";